import { render, staticRenderFns } from "./ChatbotAI.vue?vue&type=template&id=3236d6bf&scoped=true&"
import script from "./ChatbotAI.vue?vue&type=script&lang=js&"
export * from "./ChatbotAI.vue?vue&type=script&lang=js&"
import style0 from "./ChatbotAI.vue?vue&type=style&index=0&id=3236d6bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3236d6bf",
  null
  
)

export default component.exports